import { render } from "./Nurses.vue?vue&type=template&id=4caa3295"
import script from "./Nurses.vue?vue&type=script&lang=js"
export * from "./Nurses.vue?vue&type=script&lang=js"
script.render = render

export default script